import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setToken } from '../Store/authSlice';
import { AuthLayout, AuthLeftSide, LoginForm, SignupForm } from '../Components/Auth';
import VerificationForm from '../Components/Auth/VerificationForm';

type AuthMode = 'login' | 'signup' | 'verification';

export default function LoginPage() {
  const [authMode, setAuthMode] = useState<AuthMode>('login');
  const [verificationEmail, setVerificationEmail] = useState('');
  const dispatch = useDispatch();

  const handleAuthSuccess = () => {
    // The Auth.signIn or Auth.signUp will trigger the Hub listener in AuthenticatedUser
    // which will dispatch setToken, so we don't need to do anything here
    // The user will be automatically redirected to the main app
  };

  const handleSwitchToSignup = () => {
    setAuthMode('signup');
  };

  const handleSwitchToLogin = () => {
    setAuthMode('login');
  };

  const handleVerificationNeeded = (email: string) => {
    setVerificationEmail(email);
    setAuthMode('verification');
  };

  const handleVerificationSuccess = () => {
    // After successful verification, the user should be automatically signed in
    // The Hub listener in AuthenticatedUser will handle the authentication state
    setAuthMode('login');
  };

  const handleBackToSignup = () => {
    setAuthMode('signup');
  };

  const rightContent = authMode === 'login' ? (
    <LoginForm 
      onSwitchToSignup={handleSwitchToSignup}
      onSuccess={handleAuthSuccess}
      onVerificationNeeded={handleVerificationNeeded}
    />
  ) : authMode === 'signup' ? (
    <SignupForm 
      onSwitchToLogin={handleSwitchToLogin}
      onSuccess={handleAuthSuccess}
      onVerificationNeeded={handleVerificationNeeded}
    />
  ) : (
    <VerificationForm 
      email={verificationEmail}
      onVerificationSuccess={handleVerificationSuccess}
      onBackToSignup={handleBackToSignup}
    />
  );

  return (
    <AuthLayout
      leftContent={<AuthLeftSide />}
      rightContent={rightContent}
    />
  );
}
